import React from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { useSettings } from '../../../contexts/settingsContext';
import { theme } from '../../../utils/theme';
import Typography from '../../atoms/Typography';

const StyleErrorMsg = styled(Typography)`
  padding-top: 8px;
  padding-left: 8px;
`;

export default ({
  error,
  translateKey,
  onChange,
  options,
  value = '',
  className,
  name,
  placeholder = 'Select...',
  updateValue = true,
  disabled = false,
  noTranslation = false,
}) => {
  const defaultValue = () =>
    updateValue && options ? options.find((option) => option.value === value) : '';

  const { fontFamily, cornerRadius } = useSettings();

  const DropDownStyles = {
    indicatorSeparator: () => ({
      display: 'none',
    }),
    placeholder: (base) => ({
      ...base,
      fontFamily,
      fontSize: '1.2rem',
    }),
    option: (base) => ({
      ...base,
      fontFamily,
      fontSize: '1.5rem',
      cursor: 'pointer',
    }),
    control: (base) => ({
      ...base,
      fontFamily,
      fontSize: '1.5rem',
      borderRadius: cornerRadius,
      cursor: 'pointer',
    }),
    menu: (base) => ({
      ...base,
      fontFamily,
      fontSize: '1.5rem',
    }),
  };

  return (
    <div className={className}>
      {translateKey && !noTranslation && (
        <Typography translateKey={translateKey} variant="input-label" />
      )}
      {translateKey && noTranslation && (
        <Typography variant="input-label">{translateKey}</Typography>
      )}
      <Select
        isDisabled={disabled}
        name={name}
        value={defaultValue()}
        styles={DropDownStyles}
        placeholder={placeholder}
        onChange={(newValue) => {
          onChange(newValue);
        }}
        options={options}
      />
      {error && (
        <StyleErrorMsg color={theme.colors.red[80]} variant="input-error">
          {error}
        </StyleErrorMsg>
      )}
    </div>
  );
};
